import { useMutation } from "@tanstack/react-query";
import { fetchPaalaegDocumentFile } from "@/api/paalaeg";

export const useDownloadPaalaegDocument = () =>
  useMutation({
    mutationFn: (id: string) => fetchPaalaegDocumentFile(id),
  });
